module.exports = __webpack_public_path__ + "img/erosion_en.95e4913a.svg";